import { getAuthToken } from './TokenService';

const GetLatestWorkflowsRun = {
  async GetHistory(limit, offset, workflowIds = []) {
    try {
      const token = await getAuthToken();
      
      let url = `https://chat.int.bayer.com/api/v3/workflows/runs?limit=${limit}&offset=${offset}&more_details=true`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      let runsArray = [];
      if (Array.isArray(data)) {
        runsArray = data;
      } else if (Array.isArray(data?.runs)) {
        runsArray = data.runs;
      } else if (Array.isArray(data?.data)) {
        runsArray = data.data;
      } else if (Array.isArray(data?.data?.runs)) {
        runsArray = data.data.runs;
      }

      const headerTotal = parseInt(response.headers.get('x-total-count'), 10);
      let total =
        (typeof data?.total === 'number' ? data.total : null) ??
        (typeof data?.data?.total === 'number' ? data.data.total : null) ??
        (Number.isFinite(headerTotal) ? headerTotal : null);

      if (typeof total !== 'number' || Number.isNaN(total)) {
        total = runsArray.length === limit ? offset + limit + 1 : offset + runsArray.length;
      }

      return {
        runs: runsArray,
        total: total
      };
    } catch (error) {
      console.error('Error fetching workflow history:', error);
      throw error;
    }
  }
};

export { GetLatestWorkflowsRun };